<header class="topbar">
  <div class="container topbar__inner">
    <a class="brand" routerLink="/">
      <img src="assets/mark.svg" width="28" height="28" alt="Logo">
      <span class="brand__text">Card Portal</span>
    </a>

    <nav class="nav">
      <a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
      <a routerLink="/how-it-works" routerLinkActive="is-active">How it works</a>
    </nav>
  </div>
</header>

<main class="main">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>

<footer class="footer">
  <div class="container footer__inner">
    <a href="https://www.instagram.com/card_portal" target="_blank">Instagram</a>
    <a href="https://discord.gg/gf3rHTVAVK" target="_blank">Discord</a>
    <a routerLink="/impressum" routerLinkActive="is-active">Imprint</a>
    <a routerLink="/privacy-policy" routerLinkActive="is-active">Privacy Policy</a>
  </div>
</footer>